import { string } from "yup";

export const unit = () =>
  string()
    .optional()
    .typeError("Loss address is required")
    .test(
      "non-empty",
      "Loss address cannot be empty",
      (value?: string) => !value || value.trim().length > 0
    )
    .test("max-words", "Max 3 words allowed", (value) => {
      if (!value) return true;
      return value.split(" ").length <= 3;
    })
    .max(100, "Unit is too long");
